import requests from './httpService';
const AcademicYearService = {
  getAllAcademicYear(id) {
    return requests.get(`/academicyear/list/${id}`);
  },
  getActiveFinancialYear() {
    return requests.get('/academicyear/active');
  },
  getPublicAcademicYearList() {
    return requests.get('/academicyear/public/list');
  },

  createAcademicYear(body){
    return requests.post('/academicyear/add',body);
  },
  deleteAcademicYear(body){
    return requests.delete(`/academicyear/${body._id}`);
  },

  updateAcademicYear(body) {
    return requests.put(`/academicyear/${body._id}`,body);
  },

  getAcademicYearNameById(body){
    return requests.post('/academicyear/getAcademicYearNameById',body);
  },
};

export default AcademicYearService;
